module.exports = __webpack_public_path__ + "images/heart-icon.95eb0bbe.svg";